/**
 * Dialog props for a dialog rendered inside the laptop or phone frame.
 *
 * Shown inside a frame, a dialog must stay in the local DOM and leave the
 * framed app's focus and scroll alone — otherwise it portals to the document
 * body and escapes the frame it is supposed to be inside.
 *
 * A props object rather than a wrapper component. This is the only thing the
 * old Modal wrapper knew that MUI's Dialog does not, and it is behaviour, not
 * styling, so it does not need a component around it:
 *
 *   <Dialog open onClose={close} {...(inFrame ? inFrameDialogProps : {})}>
 */
export const inFrameDialogProps = {
  disablePortal: true,
  disableScrollLock: true,
  disableAutoFocus: true,
  disableEnforceFocus: true,
} as const;
